jQuery(function($) { // use jQuery code inside this to avoid "$ is not defined" error
    var $btnViewMore = jQuery('#btn_view_more'),
        max_page = $btnViewMore.data('maxpage'),
        postType = $btnViewMore.data('post-type'),
        perPage = $btnViewMore.data('per-page'),
        excludePosts = $btnViewMore.data('exclude-posts'),
        defaultText = $btnViewMore.data('default'),
        loadingText = $btnViewMore.data('loading');

    // Btn view more
    jQuery($btnViewMore).off('click').on('click', function(e) {
        e.preventDefault();

        var $blogPosts = jQuery('#blog-posts'),
            data = {
                'action': 'loadmore',
                'query': {
                    'post_type': postType,
                    'exclude_posts': excludePosts,
                    'posts_per_page': perPage,
                    'page': sjr_view_more_params.current_page,
                },
                'security': sjr_view_more_params.security
            };

        jQuery.ajax({
            url: sjr_view_more_params.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function(xhr) {
                $btnViewMore.text(loadingText);
            },
            success: function(data) {
                if (data) {
                    $btnViewMore.text(defaultText).prev().before(data);
                    sjr_view_more_params.current_page++;
                    $blogPosts.append(data);

                    if (sjr_view_more_params.current_page == max_page)
                        $btnViewMore.addClass("no-more");
                } else {
                    $btnViewMore.addClass("no-more");
                }
            }
        });
    });

    // Leadership filter
    jQuery('.tab-desktop-menu li').off('click').on('click', function(e) {
        e.preventDefault();
        var $leadershipContent = $('.leadership-content'),
            filter = $(this).data("filter");

        jQuery(".tab-desktop-menu li").removeClass("active"); //assuming that it has to be removed from other li's, else remove this line
        jQuery(this).addClass("active");
        
        $leadershipContent.removeClass('active');
        jQuery('#'+filter).addClass('active');
        var element = jQuery('[data-equalizer]');
        var elem = new Foundation.Equalizer(element);
        //$leadershipContent.attr("id", filter);
        //leadershipLoadContent(filter);
    });

    // Leadership select filter
    $('select.dropdown-mobile-menu').off('change').on('change', function(e) {
        e.preventDefault();
        var $leadershipContent = $('.leadership-content'),
            filter = this.value;

        $leadershipContent.removeClass('active');
        jQuery('#'+filter).addClass('active');
        var element = jQuery('[data-equalizer]');
        var elem = new Foundation.Equalizer(element);
    });

    jQuery('.tab-desktop-menu').on('click', 'li', function(e) {
        // e.preventDefault();
        //jQuery(".tab-desktop-menu li").removeClass("active"); //assuming that it has to be removed from other li's, else remove this line
        //jQuery(this).addClass("active");
    });

    // Ajax function to load the leadership content
    function leadershipLoadContent(filter) {

        var filter = filter,
            $leadershipContent = jQuery('.leadership-content'),
            data = {
                'action': 'leadership_content',
                'query': {
                    'post_terms': filter
                },
                'security': sjr_leadership_content.security
            };

        jQuery.ajax({
            url: sjr_leadership_content.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function(xhr) {
                //btnViewMore.text('Loading...');
            },
            success: function(data) {
                $leadershipContent.empty();
                if (data) {
                   
                    
                    $leadershipContent.append(data);

                } else {

                }
            },
            error: function(data) {
                console.log(data);
            }
        });
    }


});